import { useAuthContext } from "@/context/AuthContext";
import type { AuthContextType } from "@/context/AuthContext";

/**
 * useAuth Hook
 *
 * Provides access to authentication state and methods.
 * Must be used within an AuthProvider.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { user, signIn, signOut, loading } = useAuth();
 *
 *   if (loading) return <Spinner />;
 *
 *   if (!user) {
 *     return <button onClick={() => signIn('email', 'password')}>Sign In</button>;
 *   }
 *
 *   return (
 *     <div>
 *       <p>Welcome, {user.email}</p>
 *       <button onClick={signOut}>Sign Out</button>
 *     </div>
 *   );
 * }
 * ```
 */
export function useAuth(): AuthContextType {
  return useAuthContext();
}

export default useAuth;
